<template>
  <div>
    <!-- <vue-element-loading is-full-screen :active="loading" spinner="bar-fade-scale" class="my-15" color="#152d51" /> -->
    <div class="mb-2 flex-all-center">
      <div>
        <v-img
          class="my-0 radius-circle"
          style="width:170px;height:auto"
          src="@/assets/logo_long.png"
        ></v-img>
      </div>
    </div>
    <div class="px-5">
      <div class="text-blue">กรุณาระบุรายละเอียดของผู้ทำสัญญา</div>
      <div class="mt-5">
        <div class="text-gray">เลขบัตรประชาชน</div>
        <v-text-field-simplemask
          class="mt-3"
          v-model="input.idcard"
          label="เลขบัตรประชาชน"
          :properties="{
            prefix: '',
            suffix: '',
            dense: true,
            readonly: false,
            disabled: false,
            outlined: true,
            clearable: false,
            placeholder: ''
          }"
          :options="{
            inputMask: '#-####-#####-##-#',
            outputMask: '#############',
            empty: null,
            applyAfter: false,
            alphanumeric: true,
            lowerCase: false
          }"
        />
        <div class="text-gray">กรุณาระบุวันเดือนปีเกิด</div>
        <!-- <DatepickerCustomDialog class="w-100 my-3" v-model="input.date" style="display: inline-block" @input="onchangeDate($event)">
          <template v-slot="{ computedDate }">
            <input class="form-control" name="birth_date" data-vv-as="Birth Date" :value="computedDate" readonly placeholder="วัน/เดือน/ปีค.ศ." style="display: inline-block;background-color: rgb(255, 255, 255);" type="text" />
          </template>
        </DatepickerCustomDialog> -->
        <v-layout row wrap class="mt-5">
          <v-flex xs3>
            <v-text-field
              dense
              type="number"
              :rules="dRules"
              pattern="\d*"
              v-model="inputDate.day"
              autocomplete="off"
              label="วัน"
              min="1"
              max="31"
              outlined
            ></v-text-field>
          </v-flex>
          <v-flex xs5 class="pl-0">
            <v-text-field
              dense
              type="number"
              :rules="mRules"
              pattern="\d*"
              v-model="inputDate.month"
              autocomplete="off"
              label="เดือน เช่น 08"
              min="1"
              max="12"
              outlined
            ></v-text-field>
          </v-flex>
          <v-flex xs4 class="pl-0">
            <v-text-field
              dense
              type="number"
              :rules="yRules"
              pattern="\d*"
              v-model="inputDate.year"
              autocomplete="off"
              label="ปี พ.ศ."
              max="4"
              outlined
            ></v-text-field>
          </v-flex>
        </v-layout>
        <div class="text-gray">เลขบัตร Next Card</div>
        <v-text-field
          type="number"
          class="mt-3"
          dense
          v-model="input.nextCard"
          label="เลขบัตร Next Card 17 หลัก"
          outlined
        ></v-text-field>
        <div class="text-blue" @click="whatNextPop = true">
          <span class="fs-14" style="text-decoration: underline;">Next Card คืออะไร</span>
          <v-btn color="#23409a" x-small outlined icon><span class="fs-16 p-1">?</span></v-btn>
        </div>
      </div>
      <div class="mt-5 w-100 flex-all-center">
        <v-btn
          @click="next"
          :disabled="input.nextCard.length !== 17 || input.idcard.length !== 13 || !input.date"
          :loading="loading"
          large
          class="col-8 main-btn"
          style="color:white"
          color="#23409A"
          >ถัดไป</v-btn
        >
      </div>
    </div>
    <v-dialog
      v-model="whatNextPop"
      :overlay="false"
      max-width="500px"
      transition="dialog-transition"
    >
      <v-card class="py-2 px-5">
        <div class="text-right">
          <v-btn icon @click="whatNextPop = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <div class="my-3 col-12 flex-all-center">
          <v-img
            class="my-5 radius-circle"
            style="width:80%;height:auto"
            src="@/assets/ex_card.jpg"
          ></v-img>
        </div>
        <div class="text-center">
          บัตร Next Card คือบัตรที่ลูกค้าจะได้รับจากพนักงานเน็คซ์ พร้อมตอนรับมอบรถฯ โดยด้าน
          หน้าบัตรจะมีเลข 17 หลัก เพื่อใช้ชำระเงิน และ หลังบัตรจะมีบาร์โค้ดพร้อมรายละเอียด ค่างวดรถ
        </div>
        <div style="text-align: center;" class="mt-2">
          <v-btn color="#23409a" @click="askmore">
            <span class="text-white">สอบถามเพิ่มเติม</span>
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="show"
      scrollable
      fullscreen
      persistent
      max-width="500px"
      transition="dialog-bottom-transition"
    >
      <v-card class="py-2 px-5">
        <v-toolbar
          dark
          class="position-fixed col-12"
          style="height: 56px; top: 0; z-index: 2"
          color="#23409a"
        >
          <v-btn style="width:48xp" icon dark @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-toolbar-title class="w-100 text-center" style="margin-left:-48px"
          >รายละเอียดยอด</v-toolbar-title
        >
        <div style="margin-top:80px;background-color:white">
          <div class="mb-3 flex-all-center">
            <div>
              <v-img
                class="radius-circle"
                style="width:100px;height:auto"
                src="@/assets/logo_h.png"
              ></v-img>
            </div>
          </div>
          <div v-if="mainData && mainData.model">
            <h6 class="pl-5 text-blue mb-8">รายละเอียดสัญญา และยอดชำระ</h6>
            <contractTable :showData="mainData" />
            <div class="mb-5 w-100 flex-all-center">
              <v-btn
                :loading="loading"
                @click="$router.push('/paymentgenerate')"
                large
                class="main-btn"
                style="color:white"
                color="#23409A"
                >ขอบาร์โค้ด/คิวอาร์โค้ดเพื่อชำระเงิน</v-btn
              >
            </div>
          </div>
          <div v-else>
            <div class="text-center mt-7">
              สัญญาอยู่ระหว่างดำเนินการ
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import moment from 'moment'
import api from '@/api'
import contractTable from '@/components/contractTable.vue'
import DatepickerCustomDialog from '@/components/DatepickerCustomDialog.vue'
import config from '@/config'
import { formatThaiDate } from '@/utils/dateFormat'
export default {
  components: { VueElementLoading, contractTable, DatepickerCustomDialog },
  props: {},
  data() {
    return {
      dRules: [v => (!!v && v < 32 && v > 0) || 'วันที่ต้องไม่เกิน 31'],
      mRules: [v => (!!v && v < 13 && v > 0) || 'เดือนต้องมีค่า 01-12'],
      yRules: [v => !!v || 'Year is required'],
      input: {
        idcard: '',
        date: null,
        nextCard: '000000000'
      },
      whatNextPop: false,
      show: false,
      loading: false,
      mainData: null,
      inputDate: {
        day: null,
        month: null,
        year: null
      }
    }
  },
  computed: {
    query() {
      return this.$store.state.query
    },
    view() {
      return this.$store.state.query.view
    },
    profile() {
      return this.$store.state.profile
    },
    userId() {
      return this.$store.state.profile.userId
    }
  },
  watch: {
    inputDate: {
      immediate: true,
      deep: true,
      handler(inputDate) {
        let d = inputDate.day ? parseInt(inputDate.day) : 0
        let m = inputDate.month ? parseInt(inputDate.month) : 0
        let y = inputDate.year ? parseInt(inputDate.year) : 0
        if (d && m && y) {
          this.input.date = moment(
            new Date(parseInt(inputDate.year) - 543, parseInt(inputDate.month) - 1, inputDate.day)
          ).format('YYYY-MM-DD')
        } else {
          this.input.date = null
        }
      }
    }
  },
  mounted() {},
  methods: {
    async next() {
      this.loading = true
      await this.fetchContact()
      this.loading = false
    },
    close() {
      this.$liff.closeWindow()
    },
    onchangeDate(date) {
      this.$set(this.input, 'date', date)
    },
    async askmore() {
      await this.$store.dispatch('sendMessage', 'สอบถามเพิ่มเติมเรื่อง Next Card')
      if (this.$liff.isInClient()) {
        this.$liff.closeWindow()
      } else {
        this.$store.dispatch('messengerClose')
      }
    },
    async fetchContact() {
      let body = {
        idCard: this.input.idcard,
        birthDay: formatThaiDate(this.input.date),
        NextCard: this.input.nextCard,
        pageid: config.pageid
      }
      let res = await api.getContactNoRegised(body)
      if (res && res.responsecode == 200) {
        this.mainData = res.data
        this.$store.dispatch('setContact', this.mainData)
        this.$store.dispatch('setUserData', this.input)
        try {
          this.mainData.system_call = moment(new Date()).format('DD/MM/YYYY HH:mm')
        } catch (error) {
          this.mainData.system_call = 'error'
        }
        if (this.userid) {
          let body = {
            userid: `${this.userid}`,
            pageid: config.pageid,
            textJson: JSON.stringify(this.mainData)
          }
          let res = await api.setJsonVar(body)
          this.show = true
          this.loading = false
          if (res) {
            this.loading = false
            if (await window.liff.isInClient()) {
              this.$store.dispatch('sendMessage', 'ระบบแสดงรายละเอียดยอด')
            }
            this.show = true
          } else {
            this.loading = false
            this.$swal.fire({
              type: 'error',
              text: 'เรียกข้อมูลไม่สำเร็จ'
            })
          }
        } else {
          this.loading = false
          this.show = true
        }
      } else {
        this.$swal.fire({
          type: 'error',
          text: 'ไม่มีข้อมูลในระบบ'
        })
      }
    }
  }
}
</script>

<style>
.v-text-field--outlined.v-input--dense .v-label--active {
  background-color: white;
  /* top: 14px !important; */
}
</style>
